import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { GameEventsConstants } from "../../Constants/GameEventsConstants";
import { Helpers } from "../../Helpers/Helpers";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";

export class StickButtonController extends AnimationBaseController {
    private _isPressed = false;
    private _isEnabled = true;
    private _powerX = 0; // power for increase angle (ffrom 0 to 1)
    private _powerY = 0; // power for increase angle (ffrom 0 to 1)

    $model: GameModel;
    constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super("StickButtonController");

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: (e) => {
                if (!this._isEnabled) {
                    return;
                }
                this._isPressed = true;
                this._calc(e);
                this._gameLogic.directionChangeStart();
            },
            onPointerUp: () => {
                this._pointerUpHandler();
            },
            onPointerUpOutside: () => {
                this._pointerUpHandler();
            },
            onPointerMove: (e) => {
                if (this._isPressed && this._isEnabled) {
                    this._calc(e);
                    this._gameLogic.setPlayerAngle(this._powerX, this._powerY);
                }

            },
        }
    }

    protected onInitialize(): void {

    }

    public disable() {
        this._isPressed = false;
        this._isEnabled = false;
        this._reset();
    }

    public enable() {
        this._isEnabled = true;
    }

    private _calc(e) {
        const { x, y } = e.localPosition;
        const angle = Math.atan2(y, x); // angle beetween cursor and center
        const radius = 200; // button move area radius

        const powerRadius = radius; // touch sensitive radius

        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        this.x = Math.min(Math.abs(x), Math.abs(radius * cos)) * Helpers.sign(cos);
        this.y = Math.min(Math.abs(y), Math.abs(radius * sin)) * Helpers.sign(sin) ;

        let power = Math.sqrt(this.x*this.x+this.y*this.y) / radius;
        this._gameLogic.setPlayerPower(power);

        this._powerX = Math.min(Math.abs(x), powerRadius) * Math.cos(angle) / powerRadius;
        this._powerY = -Math.min(Math.abs(y), powerRadius) * Math.sin(angle) / powerRadius;
    }

    private _reset() {
        this._isPressed = false;
        this.x = 0;
        this.y = 0;
    }

    private _pointerUpHandler() {
        if (!this._isEnabled || !this._isPressed) {
            return;
        }
        const minRadius = 20;
        const radius = Math.sqrt(this.x*this.x + this.y*this.y);;

        this._reset();
        if (radius >= minRadius) {
            this._gameLogic.hitStart();
        } else {
            this._gameLogic.preventStart();
        }
    }

}